import React from 'react';
import PropTypes from 'prop-types';
import { filterPropType } from '../utils/propTypes';
const propTypes = {
  defaultLabel: PropTypes.string.isRequired,
  activeValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  filter: filterPropType.isRequired,
  onChange: PropTypes.func.isRequired
};
function SelectFilter(_ref) {
  let {
    defaultLabel,
    activeValues,
    filter,
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-form-group"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: `${filter.dataKey}_filter`,
    className: "asc-form-label asc-grid-filter-list-label"
  }, filter.label), /*#__PURE__*/React.createElement("div", {
    className: "asc-form-select-container"
  }, /*#__PURE__*/React.createElement("select", {
    className: "asc-form-select asc-form-select-legacy",
    id: `${filter.dataKey}_filter`,
    value: activeValues.length > 0 ? activeValues[0] : '',
    onChange: onChange
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, defaultLabel), filter.options.map(option => /*#__PURE__*/React.createElement("option", {
    key: option,
    value: option
  }, option)))));
}
SelectFilter.propTypes = propTypes;
export default SelectFilter;